import groq from "groq";
import { excludeDraftsFilter } from "../queries/filters";
import type * as Schema from "./schema";

export type State = Pick<
  Schema.State,
  | "name"
  | "image"
  | "funFact"
  | "description"
  | "code"
  | "postAdoptionAgreement"
>;

export const stateProjection: string = groq`
  {
    name,
    image,
    funFact,
    description,
    code,
    postAdoptionAgreement
  }
`;

export type StateSelectorFields = {
  states: State[];
  stateSelector: Pick<
    Schema.StateSelection,
    "header" | "secondaryHeader" | "preamble" | "moreInfo" | "image"
  >;
};

export const statesQuery = groq`
  *[_type == "state"]${stateProjection}
`;

export const stateSelectorFields: string = groq`
  "states": ${statesQuery},
  "stateSelector": *[_type == "stateSelection"][0]{
    header,
    secondaryHeader,
    preamble,
    moreInfo,
    image,
  }
`;

export const getStateSelectorImage = (preview?: boolean): string => groq`
*[_type == "stateSelection"${!preview ? ` && ${excludeDraftsFilter}` : ""}][0]{
  image
}
`;
